/** Yellow ticket chip — the Eintritt/ticket colour code applied to availability. */
import React from "react";

interface TicketChipProps {
    label: string;
}

export function TicketChip({label}: TicketChipProps) {
    return (
        <span className="inline-flex items-center whitespace-nowrap rounded-full border border-ticket bg-ticket-tint px-2 py-0.5 text-[8px] sm:text-[9px] font-semibold text-ticket-ink">
            {label}
        </span>
    );
}
